import React, { useId } from 'react';
import PropTypes from 'prop-types';
import { Button } from '../Button';
import { Icon } from '../Icon';
import { SubscriptionCardV12 } from '../SubscriptionCardV12';
import { PaymentInformationBlockV2 } from '../PaymentInformationBlockV2';
import { useIntersectionTracking } from '../../shared/use-intersection-tracking';
import { renderAgreementTerms } from '../../shared/render-agreement-terms';
import { EVENT_TYPES } from '../../../lib/shared/event-types';
import styles from './SubscriptionPlanSelectorV12.css';

const PROMO_CODE = 'welcome26';

function SubscriptionPlanSelectorV12({ plans, onSubmit, selectedSubscriptionData, selectSubscription, isPending = false, hasPromo, discountTitle, termsOfUseLink, hasBoldPrices = false }) {
    const radioGroupName = useId();
    const trackingKey = useId();

    useIntersectionTracking(`[data-tracking-key="${trackingKey}"]`);

    return (
        <div className={styles.root}>
            {hasPromo && (
                <div className={styles.promo}>
                    <p className={styles.promoTitle}>
                        <Icon name='discountTag' className={styles.promoIcon} />
                        {discountTitle}
                    </p>
                    <div className={styles.cut} aria-hidden='true' />
                    <div className={styles.promoBody}>
                        <p className={styles.code}>
                            <Icon name='checkTick' className={styles.codeIcon} />
                            {PROMO_CODE}
                        </p>
                    </div>
                </div>
            )}
            <div className={styles.plans} role='radiogroup' aria-label='Choose a plan'>
                {plans.map(plan => (
                    <SubscriptionCardV12
                        subscriptionData={plan}
                        selectedSubscriptionData={selectedSubscriptionData}
                        selectSubscription={selectSubscription}
                        isExpired={!hasPromo}
                        name={radioGroupName}
                        hasBoldPrices={hasBoldPrices}
                        key={plan.plan}
                    />
                ))}
            </div>
            {Boolean(selectedSubscriptionData.plan) && (
                <p className={styles.agreementTermsText}>
                    {renderAgreementTerms(selectedSubscriptionData, 'By clicking “Get my plan”', termsOfUseLink)}
                </p>
            )}
            <Button
                type='sunset'
                label='Get my plan'
                className={styles.button}
                onClick={() => onSubmit(selectedSubscriptionData)}
                isLoading={isPending}
            />
            <div
                className={styles.cancel}
                id={EVENT_TYPES.CANCEL_ANYTIME_BLOCK_VIEWED}
                data-tracking-key={trackingKey}
            >
                <span className={styles.cancelBadge}>
                    <Icon name='checkTick' className={styles.cancelIcon} />
                </span>
                <div>
                    <p className={styles.cancelTitle}>Cancel anytime</p>
                    <p className={styles.cancelNote}>Cancel in 2 taps from your profile</p>
                </div>
            </div>
            <PaymentInformationBlockV2 label='pay securely' />
        </div>
    );
}

SubscriptionPlanSelectorV12.propTypes = {
    plans: PropTypes.array.isRequired,
    onSubmit: PropTypes.func.isRequired,
    selectedSubscriptionData: PropTypes.object.isRequired,
    selectSubscription: PropTypes.func.isRequired,
    isPending: PropTypes.bool,
    hasPromo: PropTypes.bool.isRequired,
    discountTitle: PropTypes.string.isRequired,
    termsOfUseLink: PropTypes.string.isRequired,
    hasBoldPrices: PropTypes.bool
};

export {
    SubscriptionPlanSelectorV12
};
